<template>
  <vs-table hover-flat v-if="extensions && extensions.length" :data="extensions" class="table-configuration-queue-status-extensions-list">
    <template slot="thead">
      <vs-th v-text="$tc('extension', 1)"></vs-th>
      <vs-th v-text="$t('status')"></vs-th>
      <vs-th v-text="$t('name')"></vs-th>
      <vs-th v-text="$t('duration')"></vs-th>
      <vs-th v-text="$t('rest')"></vs-th>
      <vs-th v-text="$t('lunch')"></vs-th>
      <vs-th v-text="$t('wrapup')"></vs-th>
      <vs-th v-text="$t('ready')"></vs-th>
      <vs-th v-text="$t('total')"></vs-th>
      <vs-th v-text="$t('function')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.extension"></vs-td>
        <vs-td v-html="tr.text != null && tr.text.length > 0 ? tr.text : '--'"></vs-td>
        <vs-td v-html="tr.name != null && tr.name.length > 0 ? tr.name : '--'"></vs-td>
        <vs-td v-text="tr.time"></vs-td>
        <vs-td v-text="tr.rest"></vs-td>
        <vs-td v-text="tr.lunch"></vs-td>
        <vs-td v-text="tr.wrapup"></vs-td>
        <vs-td v-text="tr.ready"></vs-td>
        <vs-td v-text="tr.total"></vs-td>
        <vs-td>
          <vs-button
            class="text-white"
            color="success"
            type="filled"
            @click.prevent="$emit('enable', indextr)"
            v-if="!tr.enabled" v-text="$t('enable')"
            size="small">
          </vs-button>
          <vs-button
            class="text-white"
            color="danger"
            type="filled"
            @click.prevent="$emit('disable', indextr)"
            v-else
            size="small">
          </vs-button>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.Queues.Extensions.Table',
  props: {
    extensions: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .list-group-item-success {
    border: 1px solid;
    border-color: rgba(var(--vs-success),1)!important;
    color: #0f695f;
    background-color: #c0f0eb;
  }
  .list-group-item-danger {
    border: 1px solid;
    border-color: rgba(var(--vs-danger),1)!important;
    color: #841e3f;
    background-color: #fec8da;
  }
  .list-group-item-warning {
    border: 1px solid;
    border-color: rgba(var(--vs-warning),1)!important;
    color: #856012;
    background-color: #ffebc1;
  }
  .list-group-item-primary {
    border: 1px solid;
    border-color: rgba(var(--vs-primary),1)!important;
    color: #2c3e7a;
    background-color: #cfd9f9;
  }

</style>
